export const API_ERROR_CODES = {
  OK: 200,
  CREATED: 201,
  UPDATED: 202,
  DELETED: 203,
  DUPLICATE: 409,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export const EMPTY_STRING = "";

